import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import { freeCancellationWithdrawn } from '@/app/common/filters/core/filterFlags.ts';

export const getCancellationFeature = ({
  cancellation,
  isHO,
  isOverlay,
  localization,
  t,
}: GetFeaturesInnerParams): Feature[] => {
  // Same rules as the TSX card: HO only, off the map overlay, and withdrawn by cux_4082 variant T.
  if (!cancellation || !isHO || isOverlay || freeCancellationWithdrawn(localization?.configValuesApp)) return [];

  return [
    {
      icon: undefined,
      text: t('vacation.oss.components.searchresults.tour_tile.freeCancellation'),
      className: 'cancellation',
      featureType: FeatureType.normal,
    },
  ];
};
